import { useLocation, useNavigate } from 'react-router-dom';
import GenerationTicket from './Qm/GenerationTicket';

const ContenuGestionTickets = () => {
    const navigate = useNavigate()
    const location = useLocation();
    return (
        <div className='containerAA'>
            <GenerationTicket />
        </div>
    );
};

export default ContenuGestionTickets;